// // 团购
// export const GTM_DEFAULT_ARGUS = {
//   id: 'GTM-TXW84QW',
//   dataLayerName: 'haomao',
// };

// // 中秋活动 （已下线）
// export const GTM_MF_ARGUS = {
//   id: 'GTM-MMT5G86',
// };

// // app学习报告
// export const GTM_CLASS_REPORT_ARGUS = {
//   id: 'GTM-P968PHV',
// };

// // 新年抽字
// export const GTM_LOTTERY_CARD_ARGUS = {
//   id: 'GTM-P9XW7PG',
// };

// // 冬奥会活动
// export const GTM_OLYMPICS = {
//   id: 'GTM-5FQVQRD',
// };

// // 砍一刀活动
// export const GTM_CUT_A_KNIFE = {
//   id: 'GTM-KR6S6V4',
// };

// // 中文落地页
// export const GTM_CHINESE_LANDING_POSTER = {
//   id: 'GTM-NLNHS2Z',
// };
// // 中文落地页
// export const GTM_CHINESE_LANDING = {
//   id: 'GTM-PSTZVHG',
// };
// // 公开课
// export const GTM_OPEN_COURSE = {
//   id: 'GTM-MBT9XMF',
// };

// 可配置落地页
export const GTM_FORM_CONFIGURABLE = {
  id: 'GTM-NF57S3T',
};

// // 运营活动总容器
// export const GTM_OPERATION_ACTIVITY = {
//   id: 'GTM-56Q98CC',
// };

// GTM Data Layer variables 前缀
export const DATA_LAYER_VARIABLES_PRFIX = 'customer';

// GTM Data Layer variables 补全
export const DATA_LAYER_VARIABLES_MAP = {
  name: `${DATA_LAYER_VARIABLES_PRFIX}Name`, // 名字
  surname: `${DATA_LAYER_VARIABLES_PRFIX}Surname`, // 姓
  email: `${DATA_LAYER_VARIABLES_PRFIX}Email`, // 邮箱
  phone: `${DATA_LAYER_VARIABLES_PRFIX}Phone`, // 手机号
  country: `${DATA_LAYER_VARIABLES_PRFIX}Country`, // 国家
  city: `${DATA_LAYER_VARIABLES_PRFIX}City`, // 城市
  street: `${DATA_LAYER_VARIABLES_PRFIX}Street`, // 街道
  region: `${DATA_LAYER_VARIABLES_PRFIX}Region`, // 区域
  postcode: `${DATA_LAYER_VARIABLES_PRFIX}Postcode`, // 邮编
};

// // 中文年龄
// export const AGE_CHINESE = [
//   {
//     label: '3',
//     value: '3',
//   },
//   {
//     label: '4',
//     value: '4',
//   },
//   {
//     label: '5',
//     value: '5',
//   },
//   {
//     label: '6',
//     value: '6',
//   },
//   {
//     label: '7',
//     value: '7',
//   },
//   {
//     label: '8',
//     value: '8',
//   },
//   {
//     label: '9',
//     value: '9',
//   },
//   {
//     label: '10',
//     value: '10',
//   },
//   {
//     label: '11',
//     value: '11',
//   },
//   {
//     label: '12',
//     value: '12',
//   },
//   {
//     label: '13',
//     value: '13',
//   },
//   {
//     label: '14',
//     value: '14',
//   },
//   {
//     label: '15',
//     value: '15',
//   },
//   {
//     label: '16',
//     value: '16',
//   },
//   {
//     label: '17',
//     value: '17',
//   },
//   {
//     label: '18',
//     value: '18',
//   },
// ];

// // 数学年龄
// export const AGE_MATH = [
//   {
//     label: '6',
//     value: '6',
//   },
//   {
//     label: '7',
//     value: '7',
//   },
//   {
//     label: '8',
//     value: '8',
//   },
//   {
//     label: '9',
//     value: '9',
//   },
//   {
//     label: '10',
//     value: '10',
//   },
//   {
//     label: '11',
//     value: '11',
//   },
//   {
//     label: '12',
//     value: '12',
//   },
//   {
//     label: '13',
//     value: '13',
//   },
//   {
//     label: '14',
//     value: '14',
//   },
//   {
//     label: '15',
//     value: '15',
//   },
// ];

// // 学员中心 约课
// export const STUDENT_CHINESE_PRD_URL = 'https://student.wukongedu.net/reserve/chinese';
// export const STUDENT_CHINESE_PRD_EN_URL = 'https://student.wukongedu.net/en/reserve/chinese';
// export const STUDENT_CHINESE_TEST_URL = 'https://student-test.wukongedu.net/reserve/chinese';
// export const STUDENT_CHINESE_TEST_EN_URL = 'https://student-test.wukongedu.net/en/reserve/chinese';

// export const STUDENT_MATH_PRD_URL = 'https://student.wukongedu.net/reserve';
// export const STUDENT_MATH_PRD_EN_URL = 'https://student.wukongedu.net/en/reserve';
// export const STUDENT_MATH_TEST_URL = 'https://student-test.wukongedu.net/reserve';
// export const STUDENT_MATH_TEST_EN_URL = 'https://student-test.wukongedu.net/en/reserve';

// // 数学约课
// export const BOOKING_MATH_PRD_URL = 'https://wukongsch.com/math/form/#/f1';
// export const BOOKING_MATH_DEV_URL = 'https://dev.wukongedu.net/math/form/#/f3';

// // 中文约课
// export const BOOKING_CHINESE_PRD_URL = 'https://wukongedu.net/wp/chinese-landing';
// export const BOOKING_CHINESE_DEV_URL = 'https://dev.wukongedu.net/wp/chinese-landing';

// // 上报 页面名称
// // 二娃页面
// export const REPORT_PAGE_NAME_TWO_CHILD = 'FORM_TWO_CHILD';
// // 班主任中文
// export const REPORT_PAGE_NAME_CHINESE_LANDING = 'FORM_CHINESE_LANDING';
// // 公众号文章中文链接
// export const REPORT_PAGE_NAME_CHINESE_PUBLIC_ACCOUNT = 'FORM_CHINESE_PUBLIC_ACCOUNT';
// // 转介绍中文
// export const REPORT_PAGE_NAME_CHINESE_INTRODUCE = 'FORM_CHINESE_INTRODUCE';
// export const REPORT_PAGE_NAME_CHINESE_INTRODUCE_B = 'FORM_CHINESE_INTRODUCE_TESTB';
// export const REPORT_PAGE_NAME_CHINESE_INTRODUCE_C = 'FORM_CHINESE_INTRODUCE_TESTC';
// export const REPORT_PAGE_NAME_CHINESE_INTRODUCE_D = 'FORM_CHINESE_INTRODUCE_TESTD';
// export const REPORT_PAGE_NAME_CHINESE_INTRODUCE_E = 'FORM_CHINESE_INTRODUCE_TESTE';
// // 数学转介绍
// export const REPORT_PAGE_NAME_MATH_INTRODUCE = 'FORM_MATH_INTRODUCE';
// // 转介绍中文 社媒
// export const REPORT_PAGE_NAME_CHINESE_LANDING_MEDIA = 'FORM_CHINESE_LANDING_MEDIA';
// 落地页可配置
export const REPORT_PAGE_NAME_LANDING_CONFIGURABLE = 'FORM_LANDING_CONFIGURABLE';
// // 转介绍海报产品工具
// export const REPORT_PAGE_NAME_TOOL_POSTER = 'TOOL_POSTER_INDEX';
// // 转介绍海报产品工具
// export const REPORT_PAGE_NAME_TOOL_POSTER_SHARE = 'TOOL_POSTER_SHARE_INDEX';
// export const REPORT_PAGE_NAME_TOOL_POSTER_CREATE_PERSONALIZED = 'TOOL_POSTER_CREATE_PERSONALIZED_INDEX';
// export const REPORT_PAGE_NAME_TOOL_POSTER_CREATE = 'TOOL_POSTER_CREATE_INDEX';
// export const REPORT_PAGE_NAME_TOOL_POSTER_UPLOAD = 'TOOL_POSTER_UPLOAD_INDEX';
// // 内容小程序
// export const REPORT_PAGE_NAME_OPERATIONS = 'OPERATIONS';
// // 圣诞活动 首页
// export const REPORT_PAGE_NAME_CHRISTMAS_HOME = 'FORM_CHRISTMAS_HOME';
// // 圣诞活动 分享页
// export const REPORT_PAGE_NAME_CHRISTMAS_DETAILS_SHARE = 'FORM_CHRISTMAS_DETAILS_SHARE';
// // 赠送礼品卡
// export const REPORT_PAGE_NAME_GIFT_CARD = 'NEW_YEAR_GIFT_CARD';
// export const REPORT_PAGE_NAME_GIFT_SEND = 'NEW_YEAR_GIFT_RECEIVE_AWARD';
// // 邮件取消订阅
// export const REPORT_PAGE_MAIL_UNSUBSCRIBE = 'MAIL_UNSUBSCRIBE';
// // 积分商城
// export const REPORT_PAGE_WK_MALL = 'WK_MALL';
// // APP分享H5页面
// export const SHARE_APP_NAME = 'SHARE_APP';
// export const SHARE_APP_DOWNLOAD_NAME = 'DOWNLOAD_SHARE_APP';

// 二维码默认中文
export const QR_CODE_CHINESE = 'https://wkg-public.oss-us-west-1.aliyuncs.com/images/form/imgs/public-form-qrcode.png';
// 二维码默认数学
export const QR_CODE_MATH = 'https://wkg-public.oss-us-west-1.aliyuncs.com/images/form/imgs/public-form-qrcode.png';
// whatsapp二维码
export const QR_CODE_WHATSAPP = 'https://diversion.salesmartly.com/split/whatsapp/e8hf3u';
// 二维码 英文沟通语言 默认 科目通用
export const QR_CODE_SERVER_ENGLISH =
  'https://wkg-public.oss-us-west-1.aliyuncs.com/images/form/imgs/server-english-qrcode.jpg?v=12';
// // 新春活动
// export const REPORT_PAGE_NAME_SPRING_FESTIVAL_ACTIVITIES = 'SPRING_FESTIVAL_ACTIVITIES';

// // 学员中心 数学约课
// export const HM_PRD_URL = 'https://wukongedu.net';
// export const HM_TEST_URL = 'https://test.wukongedu.net';

// next语言
export const CURRENT_LANGUAGE = 'NEXT_LOCALE';
// 官网地址
export const OFFICIAL_WEBSITE_URL = 'https://www.wukongsch.com';
export const OFFICIAL_WEBSITE_EN_URL = 'https://www.wukongsch.com/en';

export const DATE_FORMAT = 'YYYY-MM-DD';
// export const DATE_FORMAT_WITH_POINT = 'YYYY.MM.DD';
// export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
// export const TIME_FORMAT = 'HH:mm:ss';
// export const TIME_FORMAT_WITHOUT_SEC = 'HH:mm';

// // 企微 结果页 多语言
// export const LANDING_RESULT_EN = {
//   btnPickUp: 'Get it Free Now',
//   pickUpReminder: 'Click the button to <span>learn free</span> immediately',
//   modelTitle: 'Add WeChat to get the course',
//   pickUpReminderLongPress: 'Scan the QR code and <span>learn free</span> immediately',
//   ScanningReminderLongPress: 'Scan the QR code and <span>learn free</span> immediately',
//   modelCourseName: 'Additional Rewards',
//   modelCourseNameMath: 'WuKong mathematics exercises',
// };
// export const LANDING_RESULT_ZH = {
//   btnPickUp: '立即领取',
//   pickUpReminder: '<span>点击上方按钮</span> 立即开通课程',
//   modelTitle: '添加老师微信 开通课程',
//   pickUpReminderLongPress: '长按识别二维码，立即免费学习',
//   ScanningReminderLongPress: '<span>微信扫码</span> 立即解锁全部福利',
//   modelCourseName: '领取配套学习福利',
//   modelCourseNameMath: '40道《悟空数学趣味练习册》',
// };

// export const AppDownHrefIos = 'https://apps.apple.com/be/app/wukong-class-learning-online/id1574837622';
// export const AppDownHrefAndroid = 'https://play.google.com/store/apps/details?id=com.wukongacademy.studentportal';

// export const APP_PUSH_TYPE = {
//   NORMAL: 'NORMAL', // 默认消息类型，打开APP，不做其他操作
//   JOINCLASS: 'JOINCLASS', // 上课提醒通知，打开APP，并跳转class in上课
//   APPLET: 'APPLET', // 小程序通知，打开APP，并跳转小程序
//   HTML: 'HTML', // h5类型通知，打开APP，并跳转H5页面
//   INTERNAL: 'INTERNAL', // 内部跳转通知，打开APP，并进行APP内部跳转
// };

// export const APP_PUSH_PATH_TYPE = {
//   normal: '',
//   home: 'home',
//   clase: 'class',
//   message: 'message',
//   mine: 'mine',
//   class_classroom: 'class/classroom',
//   class_playBack: 'class/playBack',
//   class_courseList: 'class/courseList',
//   class_learningTasks: 'class/learningTasks',
//   class_homework: 'class/homework',
//   class_studyReport: 'class/studyReport',
//   message_courseNotification: 'message/courseNotification',
//   message_serverNotification: 'message/serverNotification',
//   mine_sharePoster: 'mine/sharePoster',
//   mine_uploadScreenshot: 'mine/uploadScreenshot',
//   mine_giveClassRecord: 'mine/giveClassRecord',
//   mine_leaveList: 'mine/leaveList',
//   mine_leaveRecord: 'mine/leaveRecord',
//   mine_leaveDetail: 'mine/leaveDetail',
//   other_messageDetail: 'other/staticResource', // 消息详情页
//   other_H5: 'other/H5', // 消息详情页
//   other_applet: 'other/applet', // 消息详情页
//   mine_uploadScreenshotRecord: 'mine/uploadScreenshotRecord',
//   mine_classRecord: 'mine/classRecord', // 课时记录页面
//   mine_studentManager: 'mine/studentManager', // 学员管理页面
//   mine_studentEdit: 'mine/studentEdit', // 学员信息编辑页面
//   message_courseTimeAdjust: 'message/courseTimeAdjust', // 上课时间调整通知详情
//   mine_WuKongMall: 'mine/WuKongMall', // 悟空商城
// };

// export const SHARE_APP_DEFAULT_H5_PAGE_NAME = 'activity-configuration';

export const EMAIL_REG = /^[\w-.]+@[\w-.]+\.[a-zA-Z]{2,}$/;
export const PHONE_REG = /^[0-9\\-]{4,15}$/;
export const CARD_REG = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{13}$/;
// 只能输入1-20个汉字或者1-40个英文字母（包含空格）
export const NAME_REG = /^([\u4e00-\u9fa5]{1,20}|[a-zA-Z.\s]{1,40})$/;
// 邮箱验证码 4-6位数字
export const EMAIL_CODE_REG = /^[0-9]{4,6}$/;
export const NUMBER_REG = /^[1-9]+[0-9]*$/;

// 事件名称
// 触发“手机输入框”
export const REPORT_CLI_IPT_PHONE = 'CLK_IPT@手机号';
// 触发“邮箱输入框”
export const REPORT_CLI_IPT_MAIL = 'CLK_IPT@邮箱';
// 触发“姓名输入框”
export const REPORT_CLI_IPT_NAME = 'CLK_IPT@姓名';
// 触发“英文名输入框”
export const REPORT_CLI_IPT_ENGLISH_NAME = 'CLK_IPT@英文名';
// 触发“年龄输入框”
export const REPORT_CLI_IPT_AGE = 'CLK_BTN@年龄';
// 触发“点击免费领取按钮”
export const REPORT_CLI_IPT_BTN_GET = 'CLK_BTN@立即获取';
// 触发“吸底按钮”
export const REPORT_CLI_IPT_BTN_SUCTION_BOTTOM = 'CLK_BTN@吸底按钮';
// 触发“侧边按钮”
export const REPORT_CLI_IPT_BTN_SIDE = 'CLK_BTN@侧边按钮';
export const REPORT_PV_RETAINED_CAPITAL = 'PV_留资页';
export const REPORT_UV_RETAINED_CAPITAL = 'UV_留资页';
export const REPORT_LOAD_TIME = 'LOAD_PAGE@加载时长';
export const REPORT_PAGE_PERFORMANCE = 'LOAD_PAGE@页面性能';
export const REPORT_FERM_WRONGFORM = 'ERROR_WRONGFORM@表单报错';
// 触发“挽留”
export const REPORT_CLI_IPT_DETAIN_AGAIN = 'CLK_BTN@挽留我再想想';
export const REPORT_CLI_IPT_DETAIN_SUBMIT = 'CLK_BTN@挽留0元领取';

// 广点通埋点， 指定l参数
export const GDT_L_PARAMS = [
  '54b21ff7-f593-449a-a80a-083004471c02',
  '4a9ae16b-90f6-4032-8701-4b60db32d0c3',
  'a78931cd-2fa9-4a3e-9e69-69bf77149d60',
  '891e57db-15d3-48d0-b4f9-8ea8be87bfec',
  'dc37ce2e-6dff-43c8-a0ef-6a4cc2a20dcd',
  '9e08d30f-1d34-42f9-a8e2-4697c3b497d3',
  '19a38db3-37a9-40dd-b6ef-47d404f25136',
  '76ef2d1d-4142-43e2-9361-53196cbf8014',
  '52529a77-58ad-4808-a826-b33273d28475',
  '00ab8cc9-a8c9-4469-a9ba-bb8321874a47',
  '26e1fe16-927f-41d1-91d2-e9d86ed5a861',
  '4df91985-0a39-4fc8-a28f-932ccef68cda',
  '2daf9b78-0c42-4565-9ea4-fbf1d0c56b58',
  'f2462f0b-54b7-4274-b2fa-33cfc8a249e3',
  '27f9d04f-04de-45a8-b208-7b79a6d871f6',
];

export const PRIVACY_AGREEMENT_URL = 'https://www.wukongsch.com/policy/';
export const USER_AGREEMENT_URL = 'https://student.wukongedu.net/agreement';

export const WEEKS_FORMAT = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

export const WEEKS_FORMAT_EN = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export const YMD = 'YYYY-MM-DD';

export const USE_DEFAULT_ADS_GA_IDS = [
  '0DBisdg4',
  '0XXkbn2u',
  '1ihLEkbu',
  '1pePGkMn',
  '1QsksFrb',
  '2h9d35B7',
  '2R0tuYBe',
  '34zKpuqE',
  '383NirFY',
  '3doD4Q4P',
  '3iSAA05P',
  '3KKinWlV',
  '3sjCjGPy',
  '4cP8gq0u',
  '4U55Q3GH',
  '4utuVUe5',
  '50dC23Xo',
  '52ro2LsO',
  '5clpL98J',
  '6ZUnc1Im',
  '8HwPYP3Z',
  '8KHZ6pn2',
  '8wuy5ybz',
  'A8z2cdyr',
  'A9AH5F8b',
  'aBo7seIc',
  'avYYn7Gr',
  'AWPXxPt6',
  'axjda8UH',
  'AxzKhEoe',
  'AZUMGRDC',
  'banOJXoI',
  'bKjAPdrU',
  'BTld6FUW',
  'BuUaBXiU',
  'c82edRHf',
  'Cct3JjYT',
  'cd0TUkSi',
  'cEW6VSjJ',
  'DdDweJbL',
  'Df9S7Swt',
  'DIiQjm2i',
  'dJWr3kcm',
  'EJmCsq19',
  'EoN5Es6S',
  'erXLLlZx',
  'ev5THzvG',
  'FCPLZYOq',
  'fKhpALCo',
  'FsQqXyS0',
  'fThaieFa',
  'fUYKEtUF',
  'fxKEVL5s',
  'GgFNCrgM',
  'GLDbcMdl',
  'goStudent',
  'gqPwv6gb',
  'gVxZkcuH',
  'H05WCuxI',
  'hAM2N4zu',
  'HfaVcFtH',
  'hfQgKJZk',
  'HS2M46pJ',
  'hSY5K5OF',
  'hvc8MK64',
  'I4o6lpbX',
  'I5z2tzt2',
  'ibv4HjvR',
  'ijIN2h6C',
  'IkikbCqJ',
  'jFPKGbMl',
  'jofBNsa9',
  'JrCYSuUG',
  'jTyIFvUe',
  'jYtmfIuM',
  'KG2rdE70',
  'kumLnxJA',
  'kWakuxNv',
  'lwwSr63f',
  'm1yUzrVY',
  'M6jFQ0ry',
  'mFEvywFs',
  'mhN69vhw',
  'MLeT3OL8',
  'MMBshmKk',
  'mr3swrT5',
  'MrhxlEDc',
  'n0BgYiC7',
  'NoEu7bnc',
  'npSylT6H',
  'nxae2N3x',
  'nzU3xbBH',
  'O06ENEqR',
  'oiso1Eg6',
  'oivQHXWJ',
  'oke0ldVH',
  'oqDxcA9r',
  'oQO70s6N',
  'OUzpCttC',
  'OvGVhBsH',
  'OW6Yc9q8',
  'PBU0Odvh',
  'pGa1M9D0',
  'pLXJ4aFF',
  'PsHWyDIy',
  'pXIkT7S7',
  'qdd9UY9g',
  'QOGulBa2',
  'qRDc9zXu',
  'qXhyapAt',
  'qZIZVbHB',
  'RFUmi458',
  'rlXnIuGS',
  'rTGX604Z',
  'RvmIJhXf',
  'RW3ss2Sa',
  'sRNuPScc',
  'ST7LRWSx',
  'Su8xtbLJ',
  'T6SPHxPX',
  'Ta0KfKYq',
  'TbaVU2SJ',
  'TbphFN49',
  'TJsEummC',
  'TkdONMIq',
  'tLaKphd5',
  'tO8dyCn5',
  'tovVQe23',
  'TpTcTazK',
  'Tscy2ugU',
  'TzuEMk3f',
  'u5toS6cU',
  'udxosJ0d',
  'UgosGex5',
  'uhKSpsnM',
  'UQtQBnP2',
  'V3Ee607I',
  'V3Sn6Ll0',
  'V5aSipAk',
  'VAAY6vgd',
  'VIVYrmf7',
  'VP6jMZJT',
  'VTLppiRp',
  'WiFhi47F',
  'wn07gqgp',
  'wsqXo8Px',
  'XLOrI4Ea',
  'XMicMQUI',
  'YlkdfjtE',
  'yM6Z6hih',
  'ZCTvmhPo',
  'zGi4FeT1',
  'zGi4FeT',
  'zjGFgU7y',
  'Zy4tumvO',
  // 测试id
  'X1Ns7Tsy',
  'ECli1eLF',
];

export const GA4_IDS_MAP = {
  CHINESE: process.env.NEXT_PUBLIC_GA_ADS_CHINESE_ID,
  MATH: process.env.NEXT_PUBLIC_GA_ADS_MATH_ID,
  ENGLISH: process.env.NEXT_PUBLIC_GA_ADS_ENGLISH_ID,
};
export const CHINESE = 'zh';
export const ENGLISH = 'en';

export const SPACE = '\u00A0';

// 埋点相关source
// 预约落地页
export const PG_COLLECT = 'PG_COLLECT';

export const subjectTrans = {
  CHINESE: 'Chinese',
  MATH: 'Math',
  ENGLISH: 'English',
};

/** 科目 key → 中英文显示名映射 */
export const SUBJECT_LABEL: Record<string, { zh: string; en: string }> = {
  CHINESE: { zh: '中文', en: 'Chinese' },
  MATH: { zh: '数学', en: 'Math' },
  ENGLISH: { zh: '英文', en: 'English' },
};

// 落地页额外奖励
export const ADDITIONAL_POP_EXPOSE = 'G_AdditionalPop_Expose';
export const ADDITIONAL_POP_SCAN_WHATSAPP = 'G_AdditionalPop_ScanWhatsApp';
export const ADDITIONAL_POP_ADD_WHATSAPP = 'G_AdditionalPop_AddWhatsApp';
export const ADDITIONAL_POP_ADD_WECHAT = 'G_AdditionalPop_AddWeChat';
// 挽留弹窗埋点
export const GS_LANDING_RETAINPOP_EXPOSE = 'O_GSLandingPage_RetainPop_Expose';
export const GS_LANDING_RETAINPO_SCAN_WHATSAPP = 'O_GSLandingPage_RetainPop_ScanWhatsApp';
export const GS_LANDING_RETAINPO_ADD_WHATSAPP = 'O_GSLandingPage_RetainPop_AddWhatsApp';
export const GS_LANDING_RETAINPO_ADD_WECHAT = 'O_GSLandingPage_RetainPop_AddWeChat';
export const BACK = 'back';
export const CLOSE_VERIFICATION = 'close_verification';
export const HAS_CONTACT_INFO = 'has_contact_info';
export const NO_CONTACT_INFO = 'no_contact_info';
